import { render, staticRenderFns } from "./ClipToolPanel.vue?vue&type=template&id=05b023f0&scoped=true&"
import script from "./ClipToolPanel.vue?vue&type=script&lang=js&"
export * from "./ClipToolPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b023f0",
  null
  
)

export default component.exports